import React from 'react';
import { Company } from '../page/companypage';
import { Bagian } from '../page/footerpage';

export const CompanyPage = () => {
    window.scrollTo(0, 0);
    return (
        <>
            <Company />
            <Bagian />
        </>
    )
}